/**
 * Ein sevDesk-Kontakt als wählbare Zeile – die eine Darstellung dafür.
 *
 * Steht im Zuordnungsfenster am Kunden und in der Abgleichsliste. Beide
 * zeigen dieselbe Zeile, damit ein Treffer überall gleich aussieht und gleich
 * bedient wird: ein Klick verknüpft.
 *
 * Die Bewertung („passt gut" bei Name und Postleitzahl, sonst „ähnlich")
 * kommt vom Server; hier wird sie nur gezeigt.
 */

import type { SevdeskVorschlag } from '../typen';
import './sevdesktreffer.css';

export function SevdeskTreffer({
  kontakt,
  onWaehlen,
  beschaeftigt = false,
}: {
  kontakt: SevdeskVorschlag;
  onWaehlen: (kontakt: SevdeskVorschlag) => void;
  beschaeftigt?: boolean;
}) {
  const adresse = [kontakt.strasse, [kontakt.plz, kontakt.ort].filter(Boolean).join(' ')]
    .filter(Boolean)
    .join(', ');
  const meta = [kontakt.nummer ? `Nr. ${kontakt.nummer}` : '', adresse].filter(Boolean).join(' · ');

  return (
    <button
      type="button"
      className={`sk-treffer ${kontakt.stark ? 'stark' : ''}`}
      onClick={() => onWaehlen(kontakt)}
      disabled={beschaeftigt}
      title="Mit diesem sevDesk-Kontakt verknüpfen"
    >
      <span className={`sk-typ ${kontakt.typ}`} aria-hidden="true">
        {kontakt.typ === 'organisation' ? 'F' : 'P'}
      </span>
      <span className="sk-text">
        <span className="sk-name">{kontakt.name}</span>
        <span className="sk-meta">{meta || 'Ohne Adresse in sevDesk'}</span>
      </span>
      <span className="sk-rechts">
        {kontakt.grund && (
          <span className={`sk-grund ${kontakt.stark ? 'stark' : ''}`}>
            {kontakt.stark ? 'passt gut' : 'ähnlich'} · {kontakt.grund}
          </span>
        )}
        <span className="sk-aktion">Verknüpfen</span>
      </span>
    </button>
  );
}
